const endpoints = {
    getUserToGift: '/v1/users'
}

export default endpoints